import { SUBSHIP_TYPE, type SubshipTypeValue } from '@constants'

export const SUBSHIP_TYPE_TO_LIST_PATH: Record<SubshipTypeValue, string> = {
  [SUBSHIP_TYPE.STAGGERED_SHIPPING]: 'warehouse-order',
  [SUBSHIP_TYPE.SUBSCRIPTION]: 'subscribe-order',
}

export const SPECIAL_LOGIN_SUBSHIP_TYPE_STORAGE_KEY = 'special-login-subship-type'
